import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3H6ZM7.5 4.5C7.30109 4.5 7.11032 4.57902 6.96967 4.71967C6.82902 4.86032 6.75 5.05109 6.75 5.25V16.5C6.75017 16.6277 6.78296 16.7533 6.84525 16.8648C6.90754 16.9763 6.99727 17.07 7.10594 17.1371C7.21461 17.2042 7.33861 17.2425 7.4662 17.2482C7.59379 17.254 7.72073 17.227 7.835 17.17L12 15.089L16.165 17.172C16.2793 17.2291 16.4064 17.256 16.534 17.2502C16.6617 17.2444 16.7858 17.2061 16.8945 17.1388C17.0032 17.0716 17.0929 16.9777 17.1551 16.8661C17.2173 16.7545 17.25 16.6288 17.25 16.501V5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H7.5Z"
        fill={colorValue}
      />
    </svg>
  );
};
